import type { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { DndKitValue } from '@stratumn/studio-shared';
import { X } from 'lucide-react';
import type { ChangeEvent } from 'react';
import DragDots from '@/assets/svg/dragDotsSmall.svg?react';

import {
  ButtonIconContainer,
  GrabIconContainer,
  ItemBody,
  StyledInput
} from './sortableItem.style';

type SortableItemProps = {
  value: DndKitValue;
  onValueChange: (
    e: ChangeEvent<HTMLInputElement>,
    valueId: UniqueIdentifier
  ) => void;
  onValueDelete: (valueId: UniqueIdentifier) => void;
};

export const SortableItem = ({
  value,
  onValueChange,
  onValueDelete
}: SortableItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: value?.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: '100%'
  };

  return (
    <ItemBody ref={setNodeRef} style={style} {...attributes}>
      <GrabIconContainer {...listeners}>
        <DragDots fontSize={'25px'} />
      </GrabIconContainer>
      <StyledInput
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onValueChange(e, value.id)
        }
        value={value.name}
      />
      <ButtonIconContainer onClick={() => onValueDelete(value.id)}>
        <X color="#A4A4A4" size={13} />
      </ButtonIconContainer>
    </ItemBody>
  );
};
